export const ENEMY_TYPES = [
  'standard',
  'railgun',
  'torpedo',
  'swarmer',
  'dreadnought',
  'aegis',
  'minelayer',
  'carrier',
] as const;

export type EnemyType = typeof ENEMY_TYPES[number];

export interface EnemyInfo {
  name: string;
  description: string;
  color: string;
}

/** Player-facing intel shown on the level select screen. */
export const ENEMY_INFO: Record<EnemyType, EnemyInfo> = {
  standard: { name: 'Raider', description: 'Hunts you down and fires slow bolts', color: '#ff4444' },
  railgun: { name: 'Lancer', description: 'Charges a long-range railgun - watch the aim line', color: '#cc00ff' },
  torpedo: { name: 'Bomber', description: 'Launches homing torpedoes from both flanks', color: '#ff6600' },
  swarmer: { name: 'Swarmer', description: 'Fast kamikaze darts that attack in packs', color: '#ccff00' },
  dreadnought: { name: 'Dreadnought', description: 'Heavy armour and wide shotgun volleys', color: '#e0245e' },
  aegis: { name: 'Aegis', description: 'Regenerating shields, circles while firing', color: '#00e6b8' },
  minelayer: { name: 'Minelayer', description: 'Seeds the battlefield with proximity mines', color: '#ffd11a' },
  carrier: { name: 'Carrier', description: 'Capital ship that launches swarmer squadrons', color: '#8fa3b8' },
};
